<template lang="pug">

div

    //- Navigation
    navigation(@toggle="$emit('toggle')")

    //- Headline
    //- .ui.attached.segment
    //-     h2.ui.header
    //-         i.bookmark.icon
    //-         .content Vorlagen

    //- Keine Vorlagen
    .ui.bottom.info.icon.message(v-if='templates.length === 0')
        i.info.circle.icon
        .content: .header Keine Vorlagen vorhanden

    //- Vorlagen-Tabelle
    table.ui.bottom.table(v-else)
        thead
            tr
                th Name
                th Produkttyp
                th Erstellt am
                th
        tbody
            tr(v-for='template in templates' v-bind:key='template.id')
                td {{ template.name }}
                td {{ typeName(template.type) }}
                td {{ template.createdDate | formatDate }}
                td
                    .ui.small.buttons
                        button.ui.button(v-on:click='useTemplate(template)')
                            i.play.icon
                            |  Verwenden
                        button.ui.red.button(v-on:click='deleteTemplate(template)')
                            i.trash.icon
                            |  Löschen

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/products/Navigation'
    import { PRODUCT_TYPE_ID_TO_FORMS_KEY } from '@/utils/product/type'

    export default {

        components: { Navigation },

        async beforeRouteEnter(to, from, next) {
            await store.dispatch('productTemplates/loadAll')
            // Produkttypen der geladenen Vorlagen nachladen
            const typeIds = [...new Set(Object.values(store.state.productTemplates.entities).map(t => t.type))]
            await Promise.all(typeIds.map(id => store.dispatch('productTypes/loadOne', { id })))
            next()
        },

        filters: {
            formatDate(value) {
                if (!value) return ''
                return new Date(value).toLocaleDateString('de-DE')
            }
        },

        computed: {

            templates() {
                return this.$store.getters['productTemplates/all']
            },

        },

        methods: {

            typeName(typeId) {
                const productType = this.$store.getters['productTypes/byId'](typeId)
                return productType ? productType.name : `Typ #${typeId}`
            },

            useTemplate(template) {
                const key = PRODUCT_TYPE_ID_TO_FORMS_KEY[template.type]
                if (!key) {
                    this.$growl.fatal('Unbekannter Produkttyp – Vorlage kann nicht verwendet werden')
                    return
                }

                const variants = [...(template.variants || [])]
                    .sort((a, b) => a.number - b.number)
                    .map((v, index) => {
                        const printings = [...(v.printings || [])].sort((a, b) => a - b)
                        const fields = (v.fields || []).reduce((acc, f) => {
                            acc[f.key] = f.value
                            return acc
                        }, {})

                        return {
                            number:    index + 1,
                            printing1: printings[0] || null,
                            printing2: printings[1] || null,
                            printing3: printings[2] || null,
                            printing4: printings[3] || null,
                            printing5: printings[4] || null,
                            sorts:     v.sorts ? [...v.sorts] : [],
                            fields,
                        }
                    })

                const draft = {
                    type:              template.type,
                    company:           null,
                    proof:             { isWanted: 'NO' },
                    files:             [],
                    shippingAddresses: [{}],
                    variants,
                }

                this.$store.commit('products/RESET_DRAFT')
                this.$store.commit('products/REPLACE_DRAFT', { draft })

                this.$router.push({
                    name:   'products/create/step2',
                    params: { key },
                })
            },

            async deleteTemplate(template) {
                const confirmed = await this.$growl.confirm(
                    `Vorlage "${template.name}" wirklich löschen?`
                )
                if (!confirmed) return

                try {
                    await this.$store.dispatch('productTemplates/remove', { id: template.id })
                    this.$growl.success(`Vorlage "${template.name}" wurde gelöscht`)
                } catch (e) {
                    this.$growl.fatal('Vorlage konnte nicht gelöscht werden', e)
                }
            },

        },

    }

</script>
